import React from 'react';

import LogoutModal from '@/ebat/components/blocks/Scanbat/SessionModals/LogoutModal';
import WarningModal from '@/ebat/components/blocks/Scanbat/SessionModals/WarningModal';
import ScanbatSessionProvider from '@/ebat/contexts/ScanbatSessionContext/ScanbatSessionContext';

import {
  ScanbatLayoutDefaultProps,
  ScanbatLayoutPropTypes,
} from './ScanbatLayout.proptypes';

const ScanbatLayout = ({ children }) => (
  <ScanbatSessionProvider>
    {children}
    <LogoutModal />
    <WarningModal />
  </ScanbatSessionProvider>
);

ScanbatLayout.defaultProps = {
  ...ScanbatLayoutDefaultProps,
};

ScanbatLayout.propTypes = {
  ...ScanbatLayoutPropTypes,
};

export default ScanbatLayout;
